<!--
 * @Description: 
 * @Date: 2024-01-11 14:07:13
-->
<template>
  <div v-html="html"></div>
</template>

<script setup lang="tsx">
import { defineProps } from 'vue';
import { useTable } from '../../../hooks/use-table';

const props = defineProps<{
  tableHeaderList: any;
  tableDataList: Array<{ [key: string]: Array<string> }>;
}>();

const className = 'cross-analysis-3';
const attrs = `border='0' bordercolor='#C0BEC7'`;
const { createTable } = useTable(props.tableHeaderList, className, attrs);
const html = createTable(props.tableDataList);
</script>
<style lang="scss">
@import '../../../styles/custom-table.scss';
$border: 2pt solid #c0bec7;
.cross-analysis-3 {
  thead {
    background-color: var(--theme-color-1);
    th {
      color: #fff;
      & > div {
        border-right: $border;
        border-bottom: $border;
      }
      &:first-child {
        & > div {
          border-left: $border;
        }
      }
    }
    tr {
      &:first-child {
        th {
          & > div {
            border-top: $border;
          }
        }
      }
    }
  }
  tbody {
    tr {
      td {
        & > div {
          border-right: $border;
          border-bottom: $border;
        }
        &:first-child {
          & > div {
            border-left: $border;
          }
        }
      }
      &:nth-child(even) {
        td {
          background-color: var(--theme-color-1-10);
        }
      }
    }
  }
}
</style>
